<template lang="pug">
  .height-100
    h3.title Gestión de permisos de mi equipo
    p

    transition-group.contenedor-box(name="fade-smooth-two", tag="div")
      .box.position-relative(v-if="mostrarListaSolicitudesPorAprobar", key="lista_solicitud_por_aprobar")
        lista-solicitud-permisos-por-aprobar(
          @close="mostrarListaSolicitudesPorAprobar = false"
        )
</template>

<script>
import ListaSolicitudPermisosPorAprobarComponent from './Component_Permisos_Lista_Solicitudes_Por_Aprobar'
export default {
  name: 'permisos-equipo',
  components: {
    'lista-solicitud-permisos-por-aprobar': ListaSolicitudPermisosPorAprobarComponent
  },
  data () {
    return {
      mostrarListaSolicitudesPorAprobar: true
    }
  },
  watch : {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-box
    display flex
    justify-content center
    flex-direction column
    position relative
    >*
      transition all .5s
      width 100%
</style>



// WEBPACK FOOTER //
// View_Permisos_Mi_Equipo.vue?5418833a